export const phone = '07542 427 373'

export const email = 'info.rhythmofthenight@gmail.com'

export const socialSites = [
  { icon: 'facebook', href: 'https://www.facebook.com/rhythmofthenight'},
  { icon: 'instagram', href: 'https://www.instagram.com/rhythmofthenightband/'},
  { icon: 'twitter', href: 'https://twitter.com/ROTNband'},
  { icon: 'youtube', href: 'https://www.youtube.com/channel/UC9ZjJWVJp6ar21OeH80QGyg'}
]